import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  font-family: 'Poppins-Regular';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: #3C3B3B;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
`;

export const BreadcrumbText = styled.div`
  color: ${props => props.active ? '#D40020' : '#3C3B3B'};
  cursor: ${props => props.clickable ? 'pointer' : 'context-menu'};
`;

export const BreadcrumbRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 14px;
`;
